var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0273438H24V24.0273H0V0.0273438Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.1565L15.7417 6.41481C16.2583 5.89819 17.0959 5.89819 17.6125 6.41481C18.1292 6.93143 18.1292 7.76903 17.6125 8.28565L13.8708 12.0273L17.6125 15.769C18.1292 16.2857 18.1292 17.1233 17.6125 17.6399C17.0959 18.1565 16.2583 18.1565 15.7417 17.6399L12 13.8982L8.25831 17.6399C7.74169 18.1565 6.90408 18.1565 6.38746 17.6399C5.87085 17.1233 5.87085 16.2857 6.38746 15.769L10.1292 12.0273L6.38746 8.28565C5.87084 7.76903 5.87085 6.93143 6.38746 6.41481C6.90408 5.89819 7.74169 5.89819 8.25831 6.41481L12 10.1565Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.47765f4ffa20fdb6b1fde987d915219e.svg";
export { ForwardRef as ReactComponent };